export const Logo = ({ size = 32, className = "" }) => (
  <span className={`font-bold tracking-tight leading-none select-none ${className}`} style={className.includes("text-[") ? undefined : { fontSize: size }} data-testid="dancerfloor-logo">
    Dance<span style={{ color: "#B644DC" }}>r</span>floor
  </span>
);
